export default __webpack_public_path__ + "static/media/logo.9791eea6.png";